import * as React from "react";
import Spinner from "react-bootstrap/Spinner";

import {
  AppEvent,
  AppGuest,
  AppInvite,
  AppInviteResponse,
  AppInviteUpdate,
} from "./types";

export const formatDate = (date: number): string =>
  new Date(date * 1e3).toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
    timeZone: "America/Chicago",
  });

export const PageSpinner = () => (
  <div className="lead text-light d-flex align-items-center justify-content-center w-100 pt-5">
    <Spinner animation="border" style={{ width: "5rem", height: "5rem" }} />
  </div>
);

export const useApi = (fetch: typeof window.fetch) => {
  return React.useMemo(() => new Api(fetch), [fetch]);
};

export class Api {
  private readonly fetch: typeof window.fetch;

  constructor(fetch: typeof window.fetch) {
    this.fetch = fetch;
  }

  async getInvites(): Promise<Array<AppInvite>> {
    return (
      (await (await this.fetch("/api/invites")).json()) as {
        invites: Array<AppInvite>;
      }
    ).invites;
  }

  async getResponses(): Promise<{
    responses: Record<
      AppEvent["slug"],
      {
        event: AppEvent;
        responses: Array<
          Omit<AppInviteResponse, "guest"> & { guest: AppGuest["id"] }
        >;
      }
    >;
    updates: Array<AppInviteUpdate>;
    guests: Array<AppGuest>;
  }> {
    return (await (await this.fetch("/api/responses")).json()) as Awaited<
      ReturnType<typeof this.getResponses>
    >;
  }

  async updateInvite(
    inviteId: AppInvite["id"],
    attending: Record<number, number | null>
  ): Promise<AppInvite> {
    return (await (
      await this.fetch(`/api/invite/${inviteId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // eslint-disable-next-line camelcase
          attendee_ids: Object.fromEntries(
            Object.entries(attending).filter(
              ([, attending]) => attending != null
            )
          ),
        }),
      })
    ).json()) as AppInvite;
  }
}
